import {IconButton, Stack, TextField, Typography, Tooltip} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

export const OtherNamingCmpt = ({
  label,
  placeholder,
  other,
  setOther,
  onAdd,
  disabled = false,
}: {
  label: string;
  placeholder: string;
  other: string;
  setOther: (val: string) => void;
  onAdd?: () => void;
  disabled?: boolean;
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = String(event.target.value);
    if (!(value.length === 1 && value === ' ')) {
      setOther(value);
    }
  };

  return (
    <Stack direction='row' alignItems='center' spacing={1}>
      <Typography className='mr-2'>{label}</Typography>
      <Tooltip title={disabled ? 'Maximum 10 values allowed' : ''} arrow>
        <span>
          <TextField
            placeholder={placeholder}
            variant='outlined'
            value={other}
            onChange={handleChange}
            size='small'
            disabled={disabled}
            inputProps={{maxLength: 20}}
          />
        </span>
      </Tooltip>
      <Tooltip title={disabled ? 'Maximum 10 values allowed' : ''} arrow>
        <span>
          <IconButton
            onClick={onAdd}
            disabled={disabled || !other?.trim()}
            sx={{ml: 1, p: 1}}
            aria-label='Add'>
            <AddIcon />
          </IconButton>
        </span>
      </Tooltip>
    </Stack>
  );
};
